/**
 * @module app.cd
 */

import { autoinject } from 'aurelia-framework';
import { RouteConfig, NavigationInstruction } from 'aurelia-router';
import { I18N } from 'aurelia-i18n';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { apiCall } from 'app/shared/lib/api/api';
import { ClaimService } from 'app/cd/services/claim-service';
import * as CD from 'app/cd/models/essette-api';


@autoinject()
export class ClaimSummaryPage extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    protected claimId: string | null = null;
    protected claim: CD.Claim | null = null;


    ////****************** Element References ***************************************////



    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly service: ClaimService,
        private readonly i18n: I18N,
        ...rest: any[]) {

        super(...rest);
        this.logger.source = this;
    }

    protected async activate(params: { claimId: string }, routeConfig: RouteConfig): Promise<void> {
        if(!params?.claimId) {
            throw new Error('Missing required parameters: claimId');
        }

        this.claimId = params.claimId;
        await this.reload();

        if(this.claim && routeConfig.navModel) {
            const title = this.i18n.tr('cd:routes.claim.summary.$title', { display: this.claim?.$display });
            routeConfig.navModel.setTitle(title);
        }
    }

    ////****************** Events ***************************************************////
    public async reload(): Promise<void> {
        if(this.claimId) {
            await this.loadClaim(this.claimId);
        }
    }


    ////****************** Functions ************************************************////



    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadClaim(claimId: string): Promise<void> {
        if(!claimId) return;

        const includes: string[] = [];

        try {
            this.state.beginLoad();

            const response = await this.service.loadClaim(claimId, includes);
            this.claim = response.results[0];
        }
        catch(error) {
            throw error;
        }
        finally {
            this.state.endLoad();
        }
    }

}
